module.exports.DefLng = {
  General: {
    Load: "<h3><i class='fa fa-circle-o-notch fa-spin'></i>&nbsp;Učitavam...</h3>",
    LoadBottom: "..."
  },
  Word: {
    Welcome: "Dobro došli",
    Yes: "Da",
    No: "Ne",
    Valid: '<div class="valid-feedback">Validno</div>',
    NotValid: '<div class="invalid-feedback">Polje je obavezno!</div>',
    Months: ['(trenutan)', 'Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar']
  },
  BC: {    
    Icon: "<i class='fa fa-bars' aria-hidden='true'></i>&nbsp;&nbsp;",  
    Home: "Meni",
  },
  Wait: {
    Text: "Učitavam...",
    Small: "<span><i class='fa fa-circle-o-notch fa-spin'></i>&nbsp;Učitavam...</span>",
    Big: "<div class='row vertical-align text-center white'><div class='vertical-align-middle'><br><div class='loader-wrapper loader-lg active'><div class='loader-layer loader-blue-only'><div class='loader-circle-left'><div class='circle'></div></div><div class='loader-circle-gap'></div><div class='loader-circle-right'><div class='circle'></div></div></div></div><br><p>Loading...</p></div></div>",
  },
  NoData: {
    Small: "<i class='fa fa-outline'></i>&nbsp;&nbsp;Nema podataka!"
  },
  Error: {
    Title: "<i class='fa fa-exclamation-circle' aria-hidden='true'></i>&nbsp;&nbsp;Greška",
    Class: "alert-danger",
    Reload: {
      Title: "Pokušaj opet",
      Class: "btn btn-primary"      
    }
  },
  Btn: {
    Save: {
      Text: "Snimi",
      Class: "btn btn-success ex-action"
    },
    Cancel: {
      Text: "zatvori",
      LinkText: "Zatvori",
      Class: "btn btn-default"
    }
  },
  Page: {
    Access: {
      Login: "Login",
      Title: "Prijava",
      Checking: "<i class='fa fa-circle-o-notch fa-spin'></i>&nbsp;Sačekajte...",
      InfoKey: {
        Title: "Ključ",
        Placeholder: "Unesite korisničko ime...",
        Mandatory: "* polje je obavezno"
      },      
      UserName: {
        Title: "Korisničko ime",
        Placeholder: "Unesite korisničko ime...",
        Mandatory: "* polje je obavezno"
      },
      UserPass: {
        Title: "Lozinka",
        Placeholder: "Unesite lozinku...",
        Mandatory: "* polje je obavezno"
      },
      RememberMe: {
        Title: "&nbsp;Zapamti me",
        Forget: "Zoboravi me"
      },      
      Email: {
        Title: "Email",
        Placeholder: "Enter email for access..."
      },
      Login: {
        Title: "PRIJAVA",
        Class: "btn btn-primary"
      },
      About: "?",
      Accounts: "Accounts",
      SignUp: {
        Title: "Sign Up",
        LinkText: "Sign up for account"
      },
      Enter: {
        Title: "Enter",
        LinkText: "Enter to account",
        Class: "btn btn-sm btn-primary btn-block"
      },
      Cancel: {
        Title: "cancel",
        LinkText: "Cancel request",
        Class: "btn btn-sm btn-warning btn-link btn-block"
      },
      TryAgain: {
        Title: "Try again",
        LinkText: "Try again request",
        Class: "btn btn-primary btn-inverse"
      },
      Menu: {
        Text: "&nbsp;<i class='fa fa-home' aria-hidden='true'></i>&nbsp;Meni&nbsp;",
        Class: "btn btn-md btn-info"
      },
      Logout: {
        Text: "logout&nbsp;<i class='icon md-close' aria-hidden='true'></i>",
        Class: "btn btn-md btn-warning"
      },
      Welcome: {
        Text: "Dobro došli",
        Class: ""
      },
      ClearCache: {
        Text: "Očišti i resetuj aplikaciju",
        Class: "btn btn-sm btn-secondary"
      },
      AdminShow: {
        Text: "Admin",
        Class: "btn btn-md btn-primary"
      },
      ResetPasswordShow: {        
        Title: "Promena lozinke",
        Text: "Promeni lozinku",
        Class: "btn btn-sm btn-secondary"
      }
    },
    404: {
      Title: "Stranica nepostoji!",
      Code: "ŠIFRA 404",
      Advise: "Pokušajte sa početne stranice, da dođete do ispravn stranice.",
      Back: {
        Text: "<i class='md md-arrow-left'></i>&nbsp;idi nazad",
        Class: "btn btn-default"
      },
      Home: {
        Text: "Početna&nbsp;&nbsp;<i class='md md-home'></i>",
        Class: "btn btn-success"
      }
    },
    Logoff: {
      Title: "Odjavljujemo vas iz aplikacije [{0}]...",
      Code: "ŠIFRA 100",
      Advise: "Kliknite na <strong>idi nazad</strong> da ponišite odjavu.",
      Back: {
        Text: "<i class='fa fa-arrow-left'></i>&nbsp;&nbsp;idi nazad</span>",
        Class: "btn btn-default btn-animate"
      },
      Login: {
        Text: "<i class='fa fa-sign-in'></i>&nbsp;Odjava za [{0}]</span>",
        Class: "btn btn-success btn-animate"
      }      
    },
    Detail: {
      Delete: { 
        Text: "Izbriši",
        DialogTitle: "Izbriši",
        DialogDelete: {
          Text: "<i class='fa fa-trash-o' aria-hidden='true'></i>&nbsp;Izbriši",
          Class: "btn btn-danger"
        },
        DialogCancel: {
          Text: "zatvori",
          Class: "btn btn-secondary"
        }
      },
      Save: {
        Text: "Snimi",
        Class: "btn btn-success"
      },
      Back: {
        Text: "Nazad",
        Class: "btn btn-info"
      },
      NewRow: {
        Text: "Novo",
        Class: "badge bg-info text-uppercase"
      }     
    },
    List: {
      Excel: {
        Text: "Excel",
        Class: "btn btn-default"
      },
      Export: {
        Text: "Export",
        Class: "btn btn-default"
      },
      Import: {
        Text: "Uvezi",
        Class: "btn btn-default"
      },
      Action: {
        Title: "Akcije",
        Text: "Akcije",
        Class: "btn btn-primary",
        Yes: "Da",
        No: "Ne",
        Close: "Zatvori",
        Working: "<i class='fa fa-spinner fa-spin'></i>&nbsp;Izvršavam...",
      },
      NewRow: {
        Text: "+",
        Class: "btn btn-primary"
      },
      Back: {
        Text: "Nazad",
        Class: "btn btn-info"
      },
      Paging: {
        Title: "Stranica",
        Close: {
          Text: "zatvori",
          Class: "btn btn-secondary"
        },
        Change: {
          Text: "Primeni",
          Class: "btn btn-success"
        },
        StartRecord: {
          Text: "Pozicija"
        },
        MaxRecords: {
          Text: "Stavki po stranici"
        }
      }
    }
  },
  Site: {
    Title: "NTE Forms",
    ProfilePicture: "/style/img/logo.png",
    Description: "NTE Forms 2023",
    Year: "2023",
    Social: {
      Twitter: {
        Link: "https://twitter.com/"
      },
      Facebook: {
        Link: "https://facebook.com/"
      },
      LinkedIn: {
        Link: "https://linkedin.com/"
      }
    }
  }
};
module.exports.getDefault = function (iImport1) {
  var fResult = this.DefLng;
  if (iImport1) {
    fResult = Object.assign(fResult, iImport1.DefLng);
  }
  return fResult;
};
module.exports.getLng = function (iValue) {
  return SiteLng;
};
module.exports.getSrv = function (iName, iDefault) {
  if (SiteLng && SiteLng.Meta && SiteLng.Meta[iName] && SiteLng.Meta[iName].Srv) {
    return SiteLng.Meta[iName].Srv;
  }
  return iDefault;
};


//////////////////
// WEBPACK FOOTER
// ./ractive/Project/ERP/language-rs.js
// module id = 11
// module chunks = 0